<template>
  <div class="user">
    <div class="title-box">
      <div class="left"></div>
      <div class="title">
        <h1>{{ $route.meta.title }}</h1>
        <span></span>
      </div>
    </div>
    <div class="content">
      <transition name="el-fade-in-linear">
        <ul class="left" v-if="isBlockMenu">
          <li
            @click="changePage(item)"
            :class="item.id == glID ? 'ligl' : ''"
            v-for="item in leftMenu"
            :key="item.id"
          >
            {{ item.title }}
          </li>
          <li @click="logOut()">退出登录</li>
        </ul>
      </transition>
      <!-- <el-tabs v-else v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="个人信息" name="userinfo"></el-tab-pane>
        <el-tab-pane label="参赛作品" name="userWork"></el-tab-pane>
      </el-tabs> -->
      <transition name="el-fade-linear">
        <div class="right" v-if="!isMobile || !isBlockMenu">
          <div class="goback" @click="gobackClick" v-if="isMobile">
            <i class="el-icon-arrow-left backicon"></i>返回
          </div>
          <router-view @menuActiveHandle="menuActiveHandle"></router-view>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import { removeToken, getToken } from "../../assets/js/storage";
import { outLogin } from "../API/login";
import { getEntryInformation } from "../API/user";
import { userMenuRouter } from "../../router/menu-router";
export default {
  data() {
    return {
      leftMenu: [],
      activeName: "userinfo",
      glID: 1,
      logoutShow: true,
      WechatShow: false,
      dialogwidth: "25%",
      workstate: false,
      isMobile: document.body.clientWidth < 540 ? true : false,
      isBlockMenu: true,
    };
  },
  created() {
    if (document.body.clientWidth < 540) {
      this.logoutShow = false;
      this.dialogwidth = "80%";
    }
    this.filterMenuRoute();
  },
  methods: {
    menuActiveHandle(glid) {
      this.glID = glid;
    },
    gobackClick() {
      this.isBlockMenu = true;
    },
    filterMenuRoute() {
      const leftMenu = userMenuRouter.map((item, i) => {
        return {
          id: i + 1,
          name: item.name,
          title: item.meta.title,
        };
      });
      this.leftMenu = leftMenu;
      if (!this.isMobile) {
        this.changePage(leftMenu[0]);
      }
    },
    handleClick() {
      this.$router.push({ name: this.activeName });
    },
    // 判断用户是否报名
    async getUserWorkInfo() {
      const { data: res } = await getEntryInformation({
        phase: localStorage.getItem("phase"),
        user_id: getToken().user_id,
      });
      if (res.code !== "0000") {
        return this.$message(res.msg);
      }
      if (res.data.state !== 0) {
        this.WechatShow = true;
        this.workstate = true;
      }
    },
    changePage(item) {
      this.glID = item.id;
      this.$router.push({ name: item.name });
      if (this.isMobile) {
        this.isBlockMenu = false;
      }
    },
    async logOut() {
      const { data: res } = await outLogin();
      if (res.code == 1) {
        removeToken();
        this.$router.push({ name: "Home" });
        this.$message({
          message: "已退出登录",
          type: "success",
        });
      }
    },
  },
  components: {},
  watch: {},
};
</script>
<style scoped lang="scss">
.user {
  background-color: #f9f9f9;
  ::v-deep .el-tabs__item {
    font-size: 20px !important;
    @media screen and (max-width: 520px) {
      font-size: 18px !important;
      width: 50%;
      text-align: center;
    }
  }
  ::v-deep .el-tabs__nav {
    @media screen and (max-width: 520px) {
      width: 100%;
    }
  }
  ::v-deep .el-tabs__item:hover {
    color: #05258e !important;
  }
  ::v-deep .el-tabs__item.is-active {
    color: #05258e !important;
    font-weight: 600;
  }
  ::v-deep .el-tabs__active-bar {
    background: #05258e;
  }
  ::v-deep .el-image__error {
    background: #fff;
  }
  .title-box {
    padding: 62px 0 8px 0;
    display: flex;
    justify-content: center;
    @media screen and (max-width: 540px) {
      padding: 30px 0;
      background: #f9faff;
    }
    .left {
      padding: 30px;
      width: 390px;
      box-sizing: border-box;
      @media screen and (max-width: 540px) {
        display: none;
      }
    }
    .title {
      width: 1010px;
      @media screen and (max-width: 540px) {
        width: 100%;
      }
      h1 {
        font-size: 26px;
        text-align: center;
        color: #05258e;
        padding-bottom: 10px;
      }
      span {
        display: block;
        margin: 0px auto;
        width: 24px;
        height: 4px;
        background: #05258e;
        border-radius: 2px;
      }
    }
  }

  .content {
    display: flex;
    justify-content: center;
    padding-bottom: 150px;
    @media screen and (max-width: 540px) {
      display: block;
      padding: 0 10px;
      background: #f9faff;
    }
    .left {
      padding: 30px;
      width: 390px;
      box-sizing: border-box;
      min-height: 600px;
      background-color: #fff;
      border-radius: 6px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      @media screen and (max-width: 540px) {
        width: 100%;
        display: block;
        min-height: 100%;
        padding: 10px;
        background: #f9faff;
      }
      li {
        line-height: 60px;
        background-color: #fff;
        border-radius: 4px;
        margin-bottom: 10px;
        text-align: center;
        font-size: 18px;
        cursor: pointer;
        @media screen and (max-width: 540px) {
          flex: 1;
          margin: 0 3px;
          line-height: inherit;
          padding: 10px 0;
          font-size: 18px;
          margin-bottom: 15px;
        }
      }
      .ligl {
        color: #fff;
        background-color: #05258e !important;
      }
    }
    .right {
      .goback {
        padding-bottom: 10px;
        .backicon {
          font-size: 20px;
          font-weight: bold;
        }
      }
      @media screen and (max-width: 540px) {
        width: 100%;
        margin: 0;
        padding: 20px;
        box-sizing: border-box;
      }
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      border-radius: 6px;
      width: 970px;
      margin-left: 40px;
      background-color: #fff;
      min-height: 600px;
    }
  }
  .footer {
    display: block;
    padding-top: 50px;
    @media screen and (max-width: 540px) {
    }
  }
  .mydialog {
    height: 950px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
